import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "-mx-6 w-[calc(100%+48px)]" }
const _hoisted_2 = { class: "fixed top-[72px] left-0 z-10 bg-white px-6 py-4 shadow-[0_1px_0px_0px_rgba(0,0,0,0.08)] flex justify-between items-center w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "text-sm font-semibold" }, "Back", -1)
const _hoisted_4 = { class: "w-[220px] justify-end flex space-x-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Save & Display", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Update Form", -1)
const _hoisted_7 = {
  key: 0,
  class: "mt-[72px]"
}
const _hoisted_8 = {
  key: 0,
  class: "bg-primary-100"
}
const _hoisted_9 = {
  key: 1,
  class: "p-6"
}
const _hoisted_10 = { class: "border rounded-lg border-neutral-100" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "w-full px-6 border-t py-7" }

import { onMounted, ref, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import TabComponent from "@/components/partials/TabComponent.vue";
import FormSection from "./FormSection.vue";
import ErrorModal from "@/components/modals/ErrorModal.vue";

import { errorResponse } from "@/helpers/errorMessage";
import throttle from "lodash/throttle";
import pickBy from "lodash/pickBy";

import PageLoader from "@/components/loaders/PageLoader.vue"
import SimplePagination from "@/components/partials/SimplePagination.vue";
import ActivityLogsTable from "@/views/activity-logs/ActivityLogsTable.vue"

import { filters, items } from "@/interfaces/pages/FilterPageInterface";

import InterventionTypeService from "@/classes/Settings/InterventionTypeService.ts"
import ArrowLeftIcon from "@/components/icons/arrowLeftIcon.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const route = useRoute();
const router = useRouter();

const interventionForm = ref<number>(route?.params?.form);
const form = ref<any>({});

const formFieldTypes = ref<any>({});
const existingDropdowns = ref<any>({});

const showFilter = ref<boolean>(false);
const loading = ref<boolean>(false);
const saving = ref<boolean>(false);

const tab = ref<any>(route.query.tab);
const datatab = ref<any>(route.query.datatab);
const errors = ref<any>();
const filterSearch = ref<any>(route.query.query);
const page = ref<any>(route.query.page);
const rows = ref<any>(route.query.rows || 5);
const showSuccess = ref<boolean>(false);
const filterDate = ref<any>(route.query.date);

const newForm = ref<boolean>(false);
const formOpen = ref<boolean>(false);

const activityLogs = ref<any>([]);

const errorMessage = ref<string>('');
const showError = ref<boolean>(false);


/**
 * METHODS
 */
const tabs = ref<{ name: string; count: number; tab: string|null; href: string; allowed: boolean }[]>([
	{
		name: "Form Builder",
		count: 0,
		tab: null,
		href: `/settings/intervention-types/edit/${interventionForm.value}`,
		allowed: true,
	},
	{
		name: "Activity logs",
		count: 0,
		tab: "activity_logs",
		href: `/settings/intervention-types/edit/${interventionForm.value}?tab=activity_logs`,
		allowed: true,
	},
]);


const save = (): void => {
	saving.value = true;
    showError.value = false;
	
	InterventionTypeService
		.update(interventionForm.value, {
			form: form.value
		})
		.then((response: any) => {
			redirectSuccess()
		})
		.catch((error: any) => {
			showError.value = true;
			errors.value = error.response.data.errors;

			errorMessage.value = Object.values(errors.value)[0]
		})
		.finally(() => saving.value = false);
};

const redirectSuccess = (): void => {
	showSuccess.value = false;
	router.replace("/settings/intervention-types/index");
};

/**
 * METHODS
 */
const getData = (): void => {

	loading.value = true;
	
	InterventionTypeService
		.edit(interventionForm.value)
		.then((response: any) => {
			form.value = response.data.item;
			formFieldTypes.value = response.data.formFieldTypes;
			activityLogs.value = response.data.activityLogs;
			existingDropdowns.value = response.data.existingDropdowns
		})
		.catch((error: any) => {
			console.log(error);
		})
		.finally(() => loading.value = false);
};

const reloadPage = async () => {
	return await router.push({
		path: `/settings/intervention-types/view`,
		query: pickBy({
			query: filterSearch.value,
			page: page.value,
			rows: rows.value,
			tab: tab.value,
			datatab: datatab.value,
			date: filterDate.value,
		}),
	});
};

const applyFilters = (search: any = null) => {
	filters.value.query = search;
	showFilter.value = false;

	getData();
};

const paginate = ({ page, rows }): void => {
	filters.value = Object.assign(filters.value, {
		page, rows
	})
	getData();
};

/**
 * WATCHERS
 */
watch(
	filterSearch,
	throttle((val: string) => {
        page.value = 1;
		applyFilters(val);
	}, 1000)
);

onMounted(() => {
	getData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, { mainCustomClass: "intervention-generator" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("a", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).replace('/settings/intervention-types/index')))
          }, [
            _createVNode(ButtonComponent, { customClass: "tertiary text-black hover:text-primary-600 transition" }, {
              default: _withCtx(() => [
                _createVNode(ArrowLeftIcon, { class: "object-contain w-6 h-6 mr-2" }),
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _createVNode(TabComponent, { tabs: tabs.value }, null, 8, ["tabs"]),
          _createElementVNode("div", _hoisted_4, [
            (newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 0,
                  customClass: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (!newForm.value)
              ? (_openBlock(), _createBlock(ButtonComponent, {
                  key: 1,
                  disabled: formOpen.value,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (save())),
                  customClass: "secondary"
                }, {
                  default: _withCtx(() => [
                    _hoisted_6
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true)
          ])
        ]),
        (!loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_unref(route).query.tab != 'activity_logs')
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(FormSection, {
                      form: form.value,
                      formFieldTypes: formFieldTypes.value,
                      existingDropdowns: existingDropdowns.value,
                      onOpen: _cache[2] || (_cache[2] = ($event: any) => (formOpen.value = true)),
                      onClose: _cache[3] || (_cache[3] = ($event: any) => (formOpen.value = false))
                    }, null, 8, ["form", "formFieldTypes", "existingDropdowns"])
                  ]))
                : _createCommentVNode("", true),
              (_unref(route).query.tab === 'activity_logs')
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_unref(filters).tab != 'activity_logs')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createVNode(ActivityLogsTable, { items: activityLogs.value }, null, 8, ["items"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_12, [
                        _createVNode(SimplePagination, {
                          numRows: _unref(filters).rows,
                          currentPage: _unref(items).current_page,
                          "last-page": _unref(items).last_page,
                          onUpdate: _cache[4] || (_cache[4] = (value) => paginate(value))
                        }, null, 8, ["numRows", "currentPage", "last-page"])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(ErrorModal, {
        show: showError.value,
        onConfirm: _cache[5] || (_cache[5] = ($event: any) => (showError.value = false)),
        "action-text": "Close",
        title: "Error!",
        content: errorMessage.value
      }, null, 8, ["show", "content"]),
      _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"]),
      _createVNode(PageLoader, { show: saving.value }, null, 8, ["show"])
    ]),
    _: 1
  }))
}
}

})